module.exports = __webpack_public_path__ + "static/media/overallDefault.b042ed72.svg";